module.exports = __webpack_public_path__ + "static/media/19-1.21d6f927.mp3";